import { LucideIconName } from '@/components/custom-lucide/lucide-custom';
import { AllSubKeysMessageResource } from '@/i18n/messages';
import { memo } from 'react';
import { DossierPageCodeFilter, ProcedureStatus } from './enum';

/**Bọc generic cho HOC memo */
export const genericMemo: <T>(component: T) => T = memo;

/**Lấy ra type con trong object */
export type ExtractType<T, K extends keyof T> = T[K];

/**Type params của hàm export default trong file page.tsx */
export type PageDefParameter<T extends {} = {}> = Readonly<{
    params: { locale: string } & Record<string, string | undefined>;
    searchParams: { [key: string]: string | undefined } & T;
}>;

/**Type params của component nhận các object authentication của page */
export type PageAuthDefParameter<T extends string> = Readonly<{
    pageFunc: AuthenticationProvider<T>;
}>;

export type FuncResourceDetail = {
    isAllowed: boolean;
    name?: string;
    lucideIconName?: LucideIconName;
};

/**Object của các function phân quyền trên trang */
export type FuncResource<T extends string = string> = Record<
    T,
    FuncResourceDetail | undefined
>;

/**
 * Dữ liệu phân quyền theo từng trang
 * Sẽ phải map ra như Type dưới để sử dụng
 */
export interface AuthenticationProvider<T extends string = any> {
    func: FuncResource<T>;
}

/**Gợi ý luôn các của property bên trong object - Deep */
export type DotNotation<T extends {}> = keyof T extends never
    ? never
    : {
        [K in keyof T]: K extends string
        ? T[K] extends object
        ? `${K}` | `${K}.${DotNotation<T[K]>}`
        : `${K}`
        : never;
    }[keyof T];

/**Set state zustand */
export type SetStoreState<T> = (fn: T | ((t: T) => T)) => void;

/**Kêt hợp với TypeSetStoreState để set state vào store */
export function storeStateResolver<T = any>(
    state: T,
    params: ((t: T) => T) | T
) {
    return typeof params === 'function'
        ? (params as (t: T) => T)(state)
        : params;
}
